<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <button
                    class="right btn btn-lg btn-danger"
                    @click="getSinglePostPage(null, false)"
                >
                    <i class="fa fa-arrow-left"></i> Back to List
                </button>
            </div>
            
        </div>
        <hr>

        <!-- this applicant info template here -->
        <SinglePostPageInfo
            :applicant="applicant"
            :user="user"
            v-if="applicant"
        />

        <div class="col-lg-12" v-if="! showCentres">
            <button
                class="btn btn-lg btn-info"
                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                @click="displayCentres(true)"
            >
                <i class="fa fa-pen"></i>
                Change Posting
            </button>

            <!-- <button
                class="btn btn-lg btn-primary"
                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                @click="displayCentres(true)"
            >
                <i class="fa fa-print"></i>
                Posting Letter
            </button> -->

            <button
                class="btn btn-lg btn-danger right"
                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                @click="cancelPosting()"
            >
                <i class="fa fa-times"></i> Cancel Posting
            </button>
        </div>

        

        <div class="row" v-if="! showPostingData && ! showCentreInfo && showCentres">
            <div class="col-lg-3"></div>
            <div class="col-lg-6 text-center">
                <base-input alternative=""
                    label="Select Attachment Program Centre"
                >
                    <select
                        class="form-control form-control-alternative text-center"
                        v-model="centre"
                    >
                        <option :value="null" disabled>--- Select One ---</option>
                        <option 
                            v-for="centre in centres"
                            :key="centre.id"
                            :value="centre"
                        >
                            {{ centre.name }}
                        </option>
                    </select>
                </base-input>
            </div>
            <div class="col-lg-12">
                <button
                    class="btn btn-lg btn-info btn-block"
                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                    @click="getCentreInfo(true)"
                >
                    <i class="fa fa-check"></i>
                    Get Centre Info
                </button>
            </div>
        </div>

        <SelectedCentreInfo
            :centre="centre"
            :disableButton="disableButton"
            v-if="! showPostingData && showCentreInfo && centre && showCentres"
        />

        <PostingPageData
            :applicants="applicants"
            v-if="applicants && applicants.length > 0 && (showPostingData || showCentreInfo) && showCentres"
        />

        <div class="row" v-if="! showPostingData && showCentreInfo && showCentres">            
            <div class="col-lg-12">
                <hr>
                <base-button
                    type="success" size="lg"
                    @click="postNow()"
                    :disabled="(privileges && privileges.update == 'no') || ! privileges || disableButton"
                >
                    <i class="fa fa-check"></i> Post Now
                </base-button>

                <base-button
                    type="danger" size="lg"
                    class="right"
                    @click="getCentreInfo(false)"
                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                >
                    <i class="fa fa-times"></i> Cancel Action
                </base-button>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from 'moment';
    import PostingPageData from '../PostingPage/PostingPageData.vue';
    import SinglePostPageInfo from './SinglePostPageInfo.vue';
    import SelectedCentreInfo from './SelectedCentreInfo.vue';
    import swal from 'sweetalert2';// import sweet alert
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'SinglePostPage',
        props: ["applicant", "centres", "privileges", "loadAplications", "preloader", "getSinglePostPage"],
        components: {
            PostingPageData,
            SinglePostPageInfo,
            SelectedCentreInfo
        },
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('Do MMM, YYYY [at] h:m') : 'N/A';
            }
        },
        computed: {
            ...mapGetters(['user']),
            applicants() {
                let items = [];
                items.push(this.applicant);
                return items;
            },
            disableButton() {
                return this.centre && ((this.centre.available_space == 0) 
                    || (this.centre.available_space < this.applicants.length))
            }
        },
        data() {
            return {
                centre: null,
                showPostingData: false,
                showCentreInfo: false,
                showCentres: false
            }
        },
        methods: {
            ...mapActions(['postAttachmentApplicants', 'cancelApplicantPosting']),
            displayCentres() {
                return this.showCentres = ! this.showCentres;
            },
            getCentreInfo(status) {// get centre info
                if(this.centre) {
                    if(status) {
                        this.showCentreInfo = status
                    } else {
                        this.centre = null;
                        this.showCentreInfo = status
                    }
                } else {
                    let msg = 'Kindly select one centre, and try again';
                    swal.fire('Invalid Selection', msg, 'warning');
                }
            },
            cancelPosting() {// cancel posting
                if(this.applicant && this.applicant.id) {
                    swal.fire({
                        title: 'Are you sure?',
                        text: "You are trying to recall a post!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Proceed!'
                    }).then((result) => {
                        if (result.value) {
                            this.makeCancelPostingApiCall();// make api call
                        }
                    });
                }
            },
            makeCancelPostingApiCall() {// post applicants api
                let data = { id : this.applicant.id, admin_id : this.user.id };
                this.preloader();// show loading
                this.cancelApplicantPosting(data).then((res) => {// post applicants
                    if(res.status) {
                        swal.fire('Posting Recalled!', res.msg, 'success');
                        
                    } else {
                        swal.fire('Error Occurred!', res.msg, 'error');
                    }
                    this.loadAplications(); // reload data
                    this.getSinglePostPage(null, false);// go back
                }).
                catch(() => {
                    let msg = "Server Failure, kindly reload the page...";
                    swal.fire('Server Failure!', msg, 'error');
                });
            },
            postNow() {// post function
                let space = this.centre && this.centre.available_space ? this.centre.available_space : 0;
                let check = space >= this.applicants.length;
                if(check) {// if space is enough                
                    swal.fire({
                        title: 'Are you sure?',
                        text: "You would be able to revert this, on individual applicant!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Proceed!'
                    }).then((result) => {
                        if (result.value) {
                            this.makePostApiCall();// make api call
                        }
                    });
                } else {
                    let msg = 'No available sapce for the selected Applicants, check and try again';
                    swal.fire('No Available Space', msg, 'warning');
                }
            },
            makePostApiCall() {// post applicants api
                let data = { centre_id : this.centre.id, applicants : this.applicants, admin_id : this.user.id };
                this.preloader();// show loading
                this.postAttachmentApplicants(data).then((res) => {// post applicants
                    if(res.status) {
                        swal.fire('Applicants Posted!', res.msg, 'success');
                        
                    } else {
                        swal.fire('Error Occurred!', res.msg, 'error');
                    }
                    this.loadAplications(); // reload data
                    this.getSinglePostPage(null, false);// go back
                }).
                catch(() => {
                    let msg = "Server Failure, kindly reload the page...";
                    swal.fire('Server Failure!', msg, 'error');
                });
            }
        }
    }
</script>
<style scoped>
    .right {
        float: right !important;
    }
</style>